module.exports = __webpack_public_path__ + "static/media/edit.3e29af0f.svg";